import { routerSelector } from '../../../store/slices/router.slice';
import { useAppSelector } from '../../../store/hooks';
import { useState } from 'react';

function useComplete() {
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);
  return useState<boolean>(currentParams?.previousFocus ? true : false);
}

export default useComplete;
